// DROP DOWNS 
 
    $(document).ready(function() { 
        $('ul.sf-menu').superfish({ 
            delay:       300,                            // one second delay on mouseout 
            animation:   {opacity:'show',height:'show'},  // fade-in and slide-down animation 
            speed:       'fast',                          // faster animation speed 
            dropShadows: false                            // disable drop shadows 
        }); 
    }); 

// END OF DROP DOWNS 

// NEWS SLIDER

$(document).ready(function(){
var newsoption1 = {
  firstname: "mynews",
  secondname: "showhere",
  thirdname:"news_display",
  fourthname:"news_button" 
}
$.init_news(newsoption1);//left side 1st
//var myoffset=$('#news_button').offset();
//var mytop=myoffset.top+161;
$('#news_button').css({top:161});
});


// END OF NEWS SLIDER 


// FEATURED PRODUCT IMAGE SLIDER 

			$(document).ready(function(){
				//To switch directions up/down and left/right just place a "-" in front of the top/left attribute
				//Vertical Sliding
				$('.boxgrid.slidedown').hover(function(){
					$(".cover", this).stop().animate({top:'-260px'},{queue:false,duration:300});
				}, function() {
					$(".cover", this).stop().animate({top:'0px'},{queue:false,duration:300});
				});
				//Horizontal Sliding
				$('.boxgrid.slideright').hover(function(){
					$(".cover", this).stop().animate({left:'325px'},{queue:false,duration:300});
				}, function() {
					$(".cover", this).stop().animate({left:'0px'},{queue:false,duration:300});
				});
				//Diagnal Sliding
				$('.boxgrid.thecombo').hover(function(){
					$(".cover", this).stop().animate({top:'260px', left:'325px'},{queue:false,duration:300});
				}, function() {
					$(".cover", this).stop().animate({top:'0px', left:'0px'},{queue:false,duration:300});
				});
				//Partial Sliding (Only show some of background)
				$('.boxgrid.peek').hover(function(){
					$(".cover", this).stop().animate({top:'90px'},{queue:false,duration:160});
				}, function() {
					$(".cover", this).stop().animate({top:'0px'},{queue:false,duration:160});
				});
				//Full Caption Sliding (Hidden to Visible)
				$('.boxgrid.captionfull').hover(function(){
					$(".cover", this).stop().animate({top:'160px'},{queue:false,duration:160});
				}, function() {
					$(".cover", this).stop().animate({top:'260px'},{queue:false,duration:160});
				});
				//Caption Sliding (Partially Hidden to Visible)
				//$('.boxgrid.caption').hover(function(){
			//		$(".cover", this).stop().animate({top:'0px'},{queue:false,duration:160});
			//	}, function() {
		//			$(".cover", this).stop().animate({top:'140px'},{queue:false,duration:160});
		//		});
			});


// END OF FEATURED PRODUCT IMAGE SLIDER



// TOOL TIPS 

ShowTooltip = function(e)
{
	var text = $(this).next('.show-tooltip-text');
	if (text.attr('class') != 'show-tooltip-text')
		return false;

	text.fadeIn()
		.css('top', e.pageY)
		.css('left', e.pageX+10);

	return false;
}
HideTooltip = function(e)
{
	var text = $(this).next('.show-tooltip-text');
	if (text.attr('class') != 'show-tooltip-text')
		return false;

	text.fadeOut();
}

SetupTooltips = function()
{
	$('.show-tooltip')
		.each(function(){
			$(this)
				.after($('<span/>')
					.attr('class', 'show-tooltip-text')
					.html($(this).attr('title')))
				.attr('title', '');
		})
		.hover(ShowTooltip, HideTooltip);
}

$(document).ready(function() {
	SetupTooltips();
});

// END OF TOOL TIPS 


// ZOOM PRODUCT IMAGES 

// This is the old one, removed for the next
// $(document).ready(function() {
//    $('a.zoomerz').fancyZoom({scaleImg: false, closeOnClick: true, directory: 'http://static.shopify.com/s/files/1/0007/6902/assets'}); // no need for trailing slash
// });

$(document).ready(function() {
			$("a[rel=productimages]").fancybox({
				'titleShow'		: false,
				'transitionIn'	: 'elastic',
				'transitionOut'	: 'elastic'
			});

});


// END OF ZOOM PRODUCT IMAGES 




